module.exports = __webpack_public_path__ + "static/media/p2.cb36e41a.jpg";